export const locale = {
  lang: 'en',
  data: {
    'CONFIRMACION': {
      'FELICI':'¡CONGRATULATIONS, YOU HAVE REACHED THE END OF THE CONFIGURATION PROCESS!',
      'INDICACION':'In order for your survey to be active and ready to be applied on the configured dates, you must click on the activate survey button',
      'CONFIRMAR':'Activate survey',
      'CERRAR-CONFIRMAR':'Deactivate survey',
      'IND_CONFIRM_JP': 'Before continuing with the activation of the survey, it is necessary to confirm the information previously configured.',
      'BTN_CONFIRM_INFO': 'Confirm information ',
      'IND_ESP_CONFIRM_JP':'Once the project manager confirms, we will proceed to activate the survey.',
      'MOD_TIT_CONGR_CONF':'Thank you for your confirmation',
      'MOD_ESP_CONFIRM_JP':'We only need the approval of the project manager to proceed with the survey activation.',
      'MESSAGE5':'Active survey ready to be applied',
      'HISTORY_ACTIVATION_1': 'Last Activation/Desactivation',
      'HISTORY_ACTIVATION_2': 'Activation history:',
      'ESTATUS_SURVEY':{
        '0':'Desactivation',
        '1':'Activation',
        '2':'Closed',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          // 'MESSAGE1':'<span>To continue the activation of the survey',
          // 'MESSAGE2':', enter the text in red in the text box</span>',
          'MESSAGE1':'<span> To continue the activation of the survey, enter the text in red in the text box: ',
          'MESSAGE2':'</span>',
          'SALIR': 'Cancel',
          'VALIDAR': 'Confirm',
          'ERRORNOMBREEMPRESA': 'he text entered does not match the text indicated in red',
          'SUCCES': 'The survey was activated',
          'CERRAR': 'Close',
          'SUCCES-DES': 'The survey was deactivated',
          'MESSAGE3':'<span> To continue deactivating the survey, enter the text in red in the text box: ',
          'MESSAGE4':'</span>',
          'MESSAGE5':'Currently the survey already has results, are you sure you can deactivate it?',
          'MESSAGE6':'Currently there is no survey',
          'BTN-ACEPTAR': 'Accept',
          'BTN-CANCELAR': 'Cancel',
          'BTN-OK': 'Ok',
          'HORAMINIMA': 'The communication by email could not be confirmed, the date of the first email to send (launch or first notification, depending on the case) has to be later than two hours from this moment \n\nIf necessary, set the dates again'
        },
      },
      'MODAL_CONFIRMACION': {
        'TITULO': 'Confirmation of data',
        'INFO_1': 'We inform you that you must confirm the information of your product before continuing with the activation of the survey. We provide below the details of your company and product',
        'INFO_2': 'If the information is correct, click the <b>Confirm</b> button, otherwise, contact your Project Manager for a review',
        'TABLA': {
          'TITULOS': {
            'clave': 'Field Name',
            'valor': 'Current value'
          },
          'CAMPOS': {
            'company_name': 'Company name',
            'short_name': 'Short name',
            'publication_name': 'Publication Name',
            'company': 'Company logo',
            'certificate': 'Certificate logo',
            'foundation_year': 'Foundation year',
            'fullTime_employees': 'Number of full-time employees',
            'parcial_employees': 'Number of part-time collaborators',
            'total_employees': 'Total collaborators',
            'sector': 'Sector',
            'sub_sector': 'Subsector',
            'rankig_type': 'Ranking type',
            'ranking_name': 'Ranking name',
            'name_RH': 'Name of the HR manager',
            'email_RH': 'Email of the HR manager',
            'tel_RH': 'HR manager\'s phone number',
            'ext_RH': 'HR manager extension',
            'cel_RH': 'Cell number of the HR manager',
            'state': 'State',
            'multinational_group': 'Name of the multinational group',
            'country_application': 'Country of application',
          }
        }
      }
    },
  }
};
